import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveTrackingNumbersAndMarkAsPickedMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  tracking_numbers: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type SaveTrackingNumbersAndMarkAsPickedMutation = { __typename?: 'Mutation', saveTrackingNumbersAndMarkAsPicked: { __typename?: 'OpsOrderDetail', id: string } };


export const SaveTrackingNumbersAndMarkAsPickedDocument = gql`
    mutation SaveTrackingNumbersAndMarkAsPicked($id: ID!, $tracking_numbers: [String!]!) {
  saveTrackingNumbersAndMarkAsPicked(id: $id, tracking_numbers: $tracking_numbers) {
    id
  }
}
    `;
export type SaveTrackingNumbersAndMarkAsPickedMutationFn = Apollo.MutationFunction<SaveTrackingNumbersAndMarkAsPickedMutation, SaveTrackingNumbersAndMarkAsPickedMutationVariables>;

/**
 * __useSaveTrackingNumbersAndMarkAsPickedMutation__
 *
 * To run a mutation, you first call `useSaveTrackingNumbersAndMarkAsPickedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTrackingNumbersAndMarkAsPickedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTrackingNumbersAndMarkAsPickedMutation, { data, loading, error }] = useSaveTrackingNumbersAndMarkAsPickedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tracking_numbers: // value for 'tracking_numbers'
 *   },
 * });
 */
export function useSaveTrackingNumbersAndMarkAsPickedMutation(baseOptions?: Apollo.MutationHookOptions<SaveTrackingNumbersAndMarkAsPickedMutation, SaveTrackingNumbersAndMarkAsPickedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTrackingNumbersAndMarkAsPickedMutation, SaveTrackingNumbersAndMarkAsPickedMutationVariables>(SaveTrackingNumbersAndMarkAsPickedDocument, options);
      }
export type SaveTrackingNumbersAndMarkAsPickedMutationHookResult = ReturnType<typeof useSaveTrackingNumbersAndMarkAsPickedMutation>;
export type SaveTrackingNumbersAndMarkAsPickedMutationResult = Apollo.MutationResult<SaveTrackingNumbersAndMarkAsPickedMutation>;
export type SaveTrackingNumbersAndMarkAsPickedMutationOptions = Apollo.BaseMutationOptions<SaveTrackingNumbersAndMarkAsPickedMutation, SaveTrackingNumbersAndMarkAsPickedMutationVariables>;